import React, { Fragment } from 'react'
import { navigate } from '@reach/router';
import {
  ListGroup
} from "react-bootstrap";
import WikiNavBar from '../components/navbar';
import Footer from '../components/footer';
import useSearch from '../hooks/use_search';
import Loading from '../components/loading';


const TagPage = ({
  query,
  location,
  tag,
}) => {
  const { resultados, isBusy } = useSearch(query || location.state?.searchString || `#${tag}`)

  if (isBusy)
    return (
      <Fragment>
        <WikiNavBar />
        <Loading />
      </Fragment>
    );

  return (
    <Fragment>
      <WikiNavBar />
      <div className="container">
        <div style={{ marginTop: 24 }} />
        <h4>Resultados de tu búsqueda:</h4>
        <div style={{ marginTop: 12 }} />
        <ListGroup>
          {resultados && resultados.map((articulo) => (
            <ListGroup.Item
              className="is-clickable"
              key={articulo.nombre}
              onClick={() => navigate(encodeURI('/articulo/' + articulo.titulo))}>{articulo.titulo}
              {" "}
              <span style={{ float: 'right', color: "rgb(105, 105, 105)", fontSize: "90%" }}>{articulo.etiquetas?.map(tag => ` #${tag}`)}</span>
            </ListGroup.Item>))}
        </ListGroup>
      </div>
      <Footer />
    </Fragment>
  );
};

export default TagPage